import { render } from "./SourceInfoView.vue?vue&type=template&id=0bde6bce"
import script from "./SourceInfoView.vue?vue&type=script&lang=js"
export * from "./SourceInfoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__